import { useRef } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { getDisplayDate } from 'src/utils/dateUtils';
import {
    VISIBLE,
    OTHER_PHYSICIAN,
} from 'src/constants/appConstants';
import { SET_ITEMS_DURING_PRICING } from 'src/pages/reportUsage/redux/action/types';
import {
    getPricesForItems,
    setPageLoader,
    setProgressBarStateEditMode,
    setPhysicianTextData,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { buildPriceItemsRequest } from 'src/pages/reportUsage/utils/dataModificaionUtil';

export const useReportUsageDetailsEffect = ({
    usageDetails,
    myCaseRefId,
    updateUsageDetails,
    setIsUpdateUsageDetails,
    setUsageDetailsFailureAlert,
    setPatientDetail,
    patientDetails,
    storedPatientDetails,
    setPriceOverrideReason,
    setReportUsageFormObj,
    setPricingNotes,
    validateAccountDetails,
    setAccountValue,
    dispatch,
    procedureTypeUsageVisibility,
    setProcedureDropdown,
    setPhysicianDropdown,
    myCaseResourceType,
    t,
    usagePersistData,
    setReportPaymentGridData,
    setFilteredProduct,
    setReplenGridData,
    setLocalSignature,
    reportUsageFormObj,
    reportUsagePatientDetails,
    countryCode,
    storeUsageDataPresist,
    modifyDraftProductsResponse,
    getPatientDetailsInDraftOrder,
    currentActivity,
    getProgressBarStateOnLoad,
    orderStatusDescription,
    setPatientDetails,
    getValidReplenishGridData,
    generate_UUID,
    physicianTextUsageVisibility,
}) => {
    // Tracks whether the physician text field was auto-populated from the
    // details API so we never overwrite edits the user made afterwards.
    const hasPopulatedPhysicianTextRef = useRef(false);
    useEffectWithErrorLogging(() => {
        if (
            usageDetails &&
            Object.keys(usageDetails).length > 0 &&
            myCaseRefId &&
            (usageDetails.changeAccountEnabled ? updateUsageDetails : true)
        ) {
            setIsUpdateUsageDetails(false);
            if (usageDetails.status === 'failed') {
                setUsageDetailsFailureAlert(true);
            } else {
                setUsageDetailsFailureAlert(false);
                setPatientDetail({
                    ...patientDetails,
                    hrefId: storedPatientDetails?.hrefId
                        ? storedPatientDetails?.hrefId
                        : usageDetails.hrefId
                        ? usageDetails.hrefId
                        : '',
                    patientFirstName: storedPatientDetails?.patientFirstName
                        ? storedPatientDetails?.patientFirstName
                        : usageDetails.patientFirstName
                        ? usageDetails.patientFirstName
                        : '',
                    patientLastName: storedPatientDetails?.patientLastName
                        ? storedPatientDetails?.patientLastName
                        : usageDetails.patientLastName
                        ? usageDetails.patientLastName
                        : '',
                    patientSalutation: storedPatientDetails?.patientSalutation
                        ? storedPatientDetails?.patientSalutation
                        : usageDetails.patientSalutation
                        ? usageDetails.patientSalutation
                        : '',
                    patientSex: storedPatientDetails?.patientSex
                        ? storedPatientDetails?.patientSex
                        : usageDetails.patientSex
                        ? usageDetails.patientSex
                        : '',
                    patientDOB: storedPatientDetails?.patientDOB
                        ? getDisplayDate(
                              storedPatientDetails?.patientDOB,
                              'YYYY-MM-DD'
                          )
                        : usageDetails.patientDOB
                        ? getDisplayDate(usageDetails.patientDOB, 'YYYY-MM-DD')
                        : null,
                });
                if (usageDetails.overridenReason) {
                    setPriceOverrideReason(usageDetails.overridenReason);
                    setReportUsageFormObj((prevStateObj) => ({
                        ...prevStateObj,
                        overridenReason: usageDetails.overridenReason,
                    }));
                }
                if (usageDetails.pricingNotes) {
                    setPricingNotes(usageDetails.pricingNotes);
                    setReportUsageFormObj((prevStateObj) => ({
                        ...prevStateObj,
                        pricingNotes: usageDetails.pricingNotes,
                    }));
                }
                if (
                    usageDetails.accountId &&
                    usageDetails?.changeAccountEnabled
                ) {
                    validateAccountDetails(usageDetails?.accountId);

                    setAccountValue(usageDetails?.accountFormattedName || '');
                    const object = {
                        accountId: usageDetails?.accountId,
                        accountName: usageDetails?.accountName,
                        accountFormattedName: usageDetails?.accountFormattedName,
                    };
                    setReportUsageFormObj((prevStateObj) => ({
                        ...prevStateObj,
                        ...object,
                        isChangeAccount: usageDetails?.changeAccountEnabled || false,
                        updatedZLBAccount: usageDetails?.accountId,
                    }));
                }

                if (usageDetails?.signatureDetails) {
                    dispatch(setLocalSignature(usageDetails.signatureDetails));
                    setReportUsageFormObj((prevStateObj) => ({
                        ...prevStateObj,
                        signatureDetails: usageDetails.signatureDetails,
                    }));
                }
                if (
                    procedureTypeUsageVisibility === VISIBLE &&
                    usageDetails?.procedureCode &&
                    usageDetails?.procedureDescription
                ) {
                    setProcedureDropdown(
                        {
                            procedureCode: usageDetails.procedureCode,
                            procedureDescription: usageDetails.procedureDescription,
                        },
                        true
                    );
                }
                if (
                    usageDetails.physicianId &&
                    usageDetails.physicianName &&
                    usageDetails?.physicianId !== OTHER_PHYSICIAN
                ) {
                    setPhysicianDropdown({
                        physicianId: usageDetails.physicianId,
                        physicianDisplayName: usageDetails.physicianName,
                    });
                }
                if (usageDetails.products && usageDetails.products.length > 0) {
                    if (myCaseResourceType === 'reportPayment') {
                        const reportPaymentData = usageDetails.products
                            .map((item) => {
                                const isPoAvaiable =
                                    item.payment &&
                                    Object.keys(item.payment).length === 0;
                                return {
                                    ...item,
                                    cfn: item.productCFN,
                                    isSelected: false,
                                    isPoImageError: isPoAvaiable,
                                    isAdditionalCartEntry:
                                        item.isAdditionalCartEntry
                                            ? item.isAdditionalCartEntry
                                            : false,
                                    poImageErrorMsg: isPoAvaiable
                                        ? t('productValidationMessages.poInfoRequired')
                                        : '',
                                    isBundleItem: item?.bundleItem ? true : false,
                                    isPriceOverrideDoneInUsage:
                                        item?.overrideUnitPrice ? true : false,
                                    adjustedUsedQtyPrice:
                                        item.usedQuantity && item.overrideUnitPrice,
                                    adjustedOtherQtyPrice:
                                        item.otherQuantity && item.overrideUnitPrice,
                                    overriddenPrice: item?.overrideUnitPrice,
                                    scannedGTIN: item?.GTIN ? item.GTIN : '',
                                    unqId: `${generate_UUID()} ${item.productCFN}`,
                                    overridenUnitPriceApplied:
                                        item.overrideUnitPrice ? true : false,
                                };
                            })
                            .filter((item) => !item.isAccountOwned);

                        if (
                            reportPaymentData.some(
                                (item) => item.unitPrice?.length > 0
                            )
                        ) {
                            let cfnArray = [];
                            reportPaymentData
                                .filter((item) => item.unitPrice?.length > 0)
                                .map((item) => {
                                    if (item.bundleItem) {
                                        item.bundleItem.map((bundle) =>
                                            cfnArray.push(bundle.productCFN)
                                        );
                                    }
                                    cfnArray.push(item.productCFN);
                                });
                            dispatch({
                                type: SET_ITEMS_DURING_PRICING,
                                payload: cfnArray,
                            });
                        }
                        if (
                            usagePersistData?.showReportPayment &&
                            usagePersistData?.reportPayment?.length > 0
                        ) {
                            setReportPaymentGridData(
                                usagePersistData.reportPayment?.length > 0
                                    ? usagePersistData.reportPayment.map(
                                          (rpObj) => ({
                                              ...rpObj,
                                              isSelected: false,
                                          })
                                      )
                                    : []
                            );
                        } else {
                            setReportPaymentGridData(reportPaymentData);
                        }

                        const patientDetailsObj = getPatientDetailsInDraftOrder(
                            usageDetails,
                            reportUsagePatientDetails,
                            countryCode
                        );
                        if (Object.keys(patientDetailsObj).length > 0) {
                            dispatch(setPatientDetails(patientDetailsObj));
                        }
                        setReportUsageFormObj({
                            ...reportUsageFormObj,
                            products:
                                usagePersistData?.showReportPayment &&
                                usagePersistData?.reportPayment?.length > 0
                                    ? usagePersistData.reportPayment?.length > 0
                                        ? usagePersistData.reportPayment.map(
                                              (rpObj) => ({
                                                  ...rpObj,
                                                  isSelected: false,
                                              })
                                          )
                                        : []
                                    : usageDetails.products,
                        });
                        dispatch(
                            storeUsageDataPresist({
                                name: 'showReportPayment',
                                value: true,
                            })
                        );
                    } else {
                        const draftProducts = modifyDraftProductsResponse(
                            usageDetails.products,
                            usageDetails.bundleHeaders
                                ? usageDetails.bundleHeaders.split(',')
                                : [],
                            usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
                            false
                        );
                        setFilteredProduct(draftProducts);
                        if (
                            myCaseResourceType === 'draft' &&
                            draftProducts.length > 0 &&
                            usageDetails?.accountId
                        ) {
                            const { itemCFNs, priceItemsObj } =
                                buildPriceItemsRequest({
                                    tableData: draftProducts,
                                    bundleHeadersArr: usageDetails.bundleHeaders
                                        ? usageDetails.bundleHeaders.split(',')
                                        : [],
                                    reportPaymentTable: false,
                                    usageDetails,
                                    myCaseRefId,
                                });

                            if (itemCFNs.length > 0) {
                                dispatch({
                                    type: SET_ITEMS_DURING_PRICING,
                                    payload: itemCFNs,
                                });
                                dispatch(getPricesForItems(priceItemsObj));
                            }
                        }
                        const validReplenData = getValidReplenishGridData(
                            countryCode,
                            draftProducts,
                            [],
                            usageDetails.products
                                ? usageDetails?.products?.filter(
                                      (item) => item.isReplenish
                                  )
                                : [],
                            []
                        );
                        setReplenGridData(validReplenData);
                        if (
                            usageDetails.signatureDetails &&
                            Object.keys(usageDetails.signatureDetails).length > 0
                        ) {
                            dispatch({
                                type: 'SET_ITEM_STATE_SIGNATURE',
                                payload: JSON.parse(
                                    JSON.stringify(draftProducts)
                                ),
                            });
                            dispatch(
                                setLocalSignature(usageDetails.signatureDetails)
                            );
                        }
                    }
                }
                if (
                    myCaseResourceType === 'draft' &&
                    currentActivity === 'Record'
                ) {
                    const progressBarState =
                        getProgressBarStateOnLoad(usageDetails);
                    dispatch(setProgressBarStateEditMode(progressBarState));
                }
            }
            dispatch(setPageLoader(false)); // Stop loading
        }
    }, [myCaseRefId, usageDetails, orderStatusDescription]);

    // Auto-populate the physician text field from the details API.
    // Kept in its own effect (keyed on usageDetails + visibility) so it reacts
    // correctly when the visibility config loads after the usage details, and
    // so it does not re-run the heavy details effect above.
    useEffectWithErrorLogging(() => {
        if (physicianTextUsageVisibility !== VISIBLE) {
            // Field is hidden: clear any value we previously auto-populated so
            // stale physician text is not persisted/submitted.
            if (hasPopulatedPhysicianTextRef.current) {
                dispatch(
                    setPhysicianTextData({
                        physicianTextBoxType: 'known',
                        physicianFieldText: '',
                    })
                );
                setReportUsageFormObj((prevStateObj) => ({
                    ...prevStateObj,
                    physicianTextBoxType: 'known',
                    physicianFieldText: '',
                }));
                hasPopulatedPhysicianTextRef.current = false;
            }
            return;
        }
        // Only auto-populate once; never overwrite a value the user edited.
        if (hasPopulatedPhysicianTextRef.current || !usageDetails?.physicianName) {
            return;
        }
        const isOtherPhysician =
            usageDetails.physicianName === OTHER_PHYSICIAN;
        const physicianTextBoxType = isOtherPhysician ? 'unknown' : 'known';
        const physicianFieldText = isOtherPhysician
            ? ''
            : usageDetails.physicianName;
        dispatch(
            setPhysicianTextData({
                physicianTextBoxType,
                physicianFieldText,
            })
        );
        setReportUsageFormObj((prevStateObj) => ({
            ...prevStateObj,
            physicianTextBoxType,
            physicianFieldText,
        }));
        hasPopulatedPhysicianTextRef.current = true;
    }, [usageDetails, physicianTextUsageVisibility]);
};